import getBadgeText from "./getBadgeText";
import { withTranslation } from "../../../translation";
import styles from "./index.css";
import classNames from "classnames";
import isComingSoon from "./isComingSoon";
import PropTypes from "prop-types";
import {
  ACCESS_LEVEL_PURCHASE,
  ACCESS_LEVEL_VIEW,
} from "../../../../constants";

const EarlyAccessBadge = ({
  labels: { earlyAccessBadge: labelledById },
  earlyAccess,
  formatTranslation,
  className,
}) => {
  if (
    ![ACCESS_LEVEL_VIEW, ACCESS_LEVEL_PURCHASE].includes(
      earlyAccess?.customerAccess,
    )
  ) {
    return null;
  }

  return (
    <div
      id={labelledById}
      className={classNames(className, {
        [styles.comingSoon]: isComingSoon({ earlyAccess }),
      })}
    >
      {getBadgeText({ earlyAccess, formatTranslation })}
    </div>
  );
};

EarlyAccessBadge.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    earlyAccessBadge: PropTypes.string,
  }).isRequired,
  earlyAccess: PropTypes.shape({
    customerAccess: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default withTranslation(EarlyAccessBadge);
